import { useEffect } from 'react';
import { addAnalytic, AnalyticData } from './utils';

type Props = {
  event: string;
};
export const useSignInReport = ({ event }: Props): void => {
  useEffect(() => {
    if (!event) {
      return;
    }
    let data: AnalyticData;
    switch (event) {
      case 'security_sign_in_attempt':
      case 'security_sign_in_failure':
      case 'security_sign_in_success':
        data = {
          event
        };
        break;
      default:
        throw new Error('Invalid event on signIn report');
    }

    addAnalytic(data);
  }, [event]);
};
